import { useEffect, useState } from 'react';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

const useShouldDisplayInternalMessagingAction = ({
  user,
  onlyCurrentUser = false,
}) => {
  const { currentUser } = useDefaultAppContexts();
  const {
    messaging: { stanfordRequirements: stanfordMessagingRequirements },
  } = useFeatureFlag();
  const [displayMessagingButton, setDisplayMessagingButton] = useState(null);

  const shouldDisplayInternalMessagingAction = async () => {
    const currentUserCanAccessInternalMessaging =
      currentUser.can.access_internal_message;

    if (
      currentUserCanAccessInternalMessaging &&
      stanfordMessagingRequirements
    ) {
      const hasAccess = onlyCurrentUser
        ? await currentUserHasAccessRightToInternalMessaging()
        : await currentUserAndTargetUserHaveAccessRightToInternalMessaging(
            currentUser,
            user,
          );

      return hasAccess;
    }

    return onlyCurrentUser
      ? currentUserCanAccessInternalMessaging
      : currentUserCanAccessInternalMessaging &&
          user &&
          currentUser.id !== user.id &&
          UserIsValid(user);
  };

  useEffect(() => {
    if (currentUser && user) {
      shouldDisplayInternalMessagingAction().then(setDisplayMessagingButton);
    }
  }, [user, currentUser, stanfordMessagingRequirements, onlyCurrentUser]);

  return displayMessagingButton;
};

const UserIsValid = async (user) => {
  const accessToken = window.Hivebrite.data.access_token;

  const result = await axios
    .post('/api/user/v1/messaging/validate', {
      access_token: accessToken,
      user_id: user.id,
    })
    .then((response) => response.data.user.can);

  return result;
};

const currentUserHasAccessRightToInternalMessaging = async () => {
  const accessToken = window.Hivebrite.data.access_token;

  const result = await axios
    .post('/api/user/v1/messaging/access', {
      access_token: accessToken,
    })
    .then(() => true)
    .catch(() => false);

  return result;
};

const currentUserAndTargetUserHaveAccessRightToInternalMessaging = async (
  currentUser,
  user,
) => {
  if (currentUser.id === user.id) {
    return false;
  }

  const accessToken = window.Hivebrite.data.access_token;

  const currentUserCanMessageUser = await axios
    .post('/api/user/v1/messaging/access', {
      access_token: accessToken,
      scope: 'users',
      user_ids: [user.id],
    })
    .then((response) => response.data.user_ids[0].can);

  return currentUserCanMessageUser;
};

export default useShouldDisplayInternalMessagingAction;
